// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./LanguageContext";
import EditableJson from "./EditableJson";
import AdminPanel from "./AdminPanel";
import Support from "./Support";
import SupportAdmin from "./SupportAdmin";
import UserForm from "./UserForm";
import Login from "./components/Login";
import UserDashboard from "./UserDashboard";
import UserEditableJson from "./UserEditableJson";
import UserAccount from "./UserAccount";
import AdminEditableJson from "./AdminEditableJson";
import AdminEditableList from "./AdminEditableList";
import AdminUserList from "./AdminUserList";
import AdminEditableForUserJson from "./AdminEditableForUserJson";
import UserSupport from "./UserSupport";
import AdminUserRoleControl from "./AdminUserRoleControl";
import ForgotPassword from "./ForgotPassword";
import UserUpdateEditableJson from "./UserUpdateEditableJson";
import AdminForSelfUpdateEditableJson from "./AdminForSelfUpdateEditableJson";
import AdminUpdateEditableJson from "./AdminUpdateEditableJson";
const App = () => {
  return (
    <LanguageProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/support" element={<Support />} />
          <Route path="/supportadmin" element={<SupportAdmin />} />
          <Route path="/userform" element={<UserForm />} />
          <Route path="/userdashboard" element={<UserDashboard />} />
          <Route path="/usereditalbejson" element={<UserEditableJson />} />
          <Route path="/useraccount" element={<UserAccount />} />
          <Route path="/admineditablejson" element={<AdminEditableJson />} />
          <Route path="/admineditableList" element={<AdminEditableList />} />
          <Route path="/adminuserlist" element={<AdminUserList />} />
          <Route path="/admineditableforuserjson" element={<AdminEditableForUserJson />} />
          <Route path="/usersupport" element={<UserSupport />} />
          <Route path="/adminuserrolecontrol" element={<AdminUserRoleControl />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/userupdateedtablejson" element={<UserUpdateEditableJson />} />
          <Route path="/adminforselfupdateeditablejson" element={<AdminForSelfUpdateEditableJson />} />
          <Route path="/adminupdateeditablejson" element={<AdminUpdateEditableJson />} />
        </Routes>
      </Router>
    </LanguageProvider>
  );
};

export default App;
